import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import req from "../../axios/interceptedAxiosInstance";

export const getUserFavourite = createAsyncThunk(
  "favourite/getUserFavourite",
  async () => {
    const response = await req.get("favourite/fetch");
    return response.data.data;
  }
);

const initialState = {
  favourite: [],
};

const favouriteSlice = createSlice({
  name: "favourite",
  initialState,
  reducers: {
    addToFav: (state, action) => {
      return {
        ...state,
        favourite: [...state.favourite, action.payload],
      };
    },
    removeFromFav: (state, action) => {
      return {
        ...state,
        favourite: state.favourite.filter((fav) => fav.id !== action.payload),
      };
    },
  },
  extraReducers: (builder) => [
    builder.addCase(getUserFavourite.fulfilled, (state, action) => {
      state.favourite = action.payload;
    }),
  ],
});

export const { addToFav, removeFromFav } = favouriteSlice.actions;
export default favouriteSlice.reducer;
